/* ==========================================================================
   Gadport — estados de carga
   --------------------------------------------------------------------------
   Tres cosas, ninguna decorativa:

   1. Apagar el brillo del hueco cuando la foto llegó.
   2. Marcar el botón como ocupado al enviar un formulario, para que nadie
      mande dos veces el mismo mensaje.
   3. Mostrar una barra al tocar un enlace interno. En un celular lento, sin
      respuesta inmediata la persona toca de nuevo.

   Todo con red: si algo falla, la página queda usable igual.
   ========================================================================== */

(function () {
  'use strict';

  var CAJAS = '.gp-card__media, .gp-shot__media, .gp-case__media, ' +
              '.gp-about__media, .gp-photo, .gp-404__media';

  // ------------------------------------------------------------------ fotos
  function marcar(caja) {
    if (caja) caja.classList.add('is-loaded');
  }

  function vigilarFotos() {
    var cajas = document.querySelectorAll(CAJAS);

    Array.prototype.forEach.call(cajas, function (caja) {
      var img = caja.querySelector('img');

      // Sin imagen (por ejemplo un hueco con el brief de la foto que falta)
      // el brillo no tiene sentido: se apaga.
      if (!img) { marcar(caja); return; }

      if (img.complete && img.naturalWidth > 0) { marcar(caja); return; }

      img.addEventListener('load', function () { marcar(caja); }, { once: true });
      // Si la foto falla, tampoco se deja el brillo latiendo para siempre.
      img.addEventListener('error', function () { marcar(caja); }, { once: true });
    });
  }

  // Red de seguridad: a los 6 segundos se apaga todo brillo que siga prendido.
  function apagarTodo() {
    Array.prototype.forEach.call(document.querySelectorAll(CAJAS), marcar);
  }

  // -------------------------------------------------------------- formularios
  function vigilarFormularios() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;

      var btn = form.querySelector('button[type="submit"], .gp-btn[type="submit"]');
      if (!btn) return;

      btn.setAttribute('aria-busy', 'true');

      // Si la validación del navegador frena el envío, el botón tiene que
      // volver a estar disponible.
      setTimeout(function () {
        if (!form.checkValidity || form.checkValidity()) return;
        btn.removeAttribute('aria-busy');
      }, 80);
    });
  }

  // ---------------------------------------------------------- navegación
  var barra = null;

  function montarBarra() {
    barra = document.createElement('div');
    barra.className = 'gp-navload';
    barra.setAttribute('aria-hidden', 'true');
    var b = document.createElement('div');
    b.className = 'gp-navload__bar';
    barra.appendChild(b);
    document.body.appendChild(barra);
  }

  function esInterno(a) {
    if (!a || !a.href) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download')) return false;
    if (a.getAttribute('href').charAt(0) === '#') return false;

    var proto = a.protocol;
    if (proto !== 'http:' && proto !== 'https:') return false;   // mailto, tel, wa.me
    if (a.host !== window.location.host) return false;

    // Un ancla de la misma página no navega a ningún lado.
    if (a.pathname === window.location.pathname && a.hash) return false;

    return true;
  }

  function vigilarEnlaces() {
    document.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

      var a = e.target.closest ? e.target.closest('a') : null;
      if (!esInterno(a)) return;

      if (barra) barra.classList.add('is-on');
    });

    // Al volver con el botón atrás, la página sale de la caché y la barra
    // podría quedar encendida.
    window.addEventListener('pageshow', function () {
      if (barra) barra.classList.remove('is-on');
    });
  }

  function arrancar() {
    vigilarFotos();
    vigilarFormularios();
    montarBarra();
    vigilarEnlaces();
    setTimeout(apagarTodo, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // En el personalizador las secciones se vuelven a montar.
  document.addEventListener('shopify:section:load', vigilarFotos);
})();

/* ==========================================================================
   Gadport — alto de la barra de compra fija
   --------------------------------------------------------------------------
   02-oct-2026: abajo conviven dos barras de compra fijas, la del tema
   (.gp-sticky, en la home) y la de BundleX (.bx-sticky-atc, en la ficha), y
   la de BundleX cambia de alto segun el largo del titulo. Esto publica en
   --gp-bottom-bar-h cuanto ocupa la que esta a la vista, para que lo que
   flota abajo (el teaser "10% OFF" de Klaviyo) se apoye encima en vez de
   tapar el boton de comprar.
   ========================================================================== */

(function () {
  'use strict';

  var BARRAS = '.gp-sticky, .bx-sticky-atc';
  var VISIBLES = '.gp-sticky.is-visible, .bx-sticky-atc--visible';
  var raiz = document.documentElement;
  var actual = -1;

  function medir() {
    var alto = 0;
    var barras = document.querySelectorAll(VISIBLES);

    // offsetHeight y no getBoundingClientRect: las barras entran con un
    // transform, y a mitad de la animacion el rect daria un alto a medias.
    for (var i = 0; i < barras.length; i++) {
      if (barras[i].offsetHeight > alto) alto = barras[i].offsetHeight;
    }

    if (alto !== actual) {
      actual = alto;
      raiz.style.setProperty('--gp-bottom-bar-h', alto + 'px');
    }
  }

  // Cada barra cambia de clase al aparecer y desaparecer. La de BundleX la
  // inyecta la app despues de cargar, por eso se busca de nuevo con el scroll.
  var vigia = window.MutationObserver ? new MutationObserver(medir) : null;

  function enganchar() {
    var barras = document.querySelectorAll(BARRAS);
    for (var i = 0; i < barras.length; i++) {
      if (vigia && !barras[i].hasAttribute('data-gp-medida')) {
        barras[i].setAttribute('data-gp-medida', '');
        vigia.observe(barras[i], { attributes: true, attributeFilter: ['class'] });
      }
    }
    medir();
  }

  window.addEventListener('scroll', enganchar, { passive: true });
  window.addEventListener('resize', medir, { passive: true });
  window.addEventListener('load', enganchar);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enganchar);
  } else {
    enganchar();
  }
})();
